/* ClothyCorp store helpers v6: icons, sizes in stock on product cards, cart reassurance, active chips */
(function () {
  var P = {
    truck: '<path d="M2 6.5h11v9H2zM13 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/>',
    cod: '<rect x="2.5" y="6" width="19" height="12" rx="2"/><circle cx="12" cy="12" r="2.6"/><path d="M6 9.5v5M18 9.5v5"/>',
    swap: '<path d="M4 8h13l-3-3M20 16H7l3 3"/>',
    lock: '<rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>',
    leaf: '<path d="M5 19c0-8 5-13 15-14-1 10-6 15-14 15"/><path d="M5 19 14 10"/>',
    ruler: '<rect x="2.5" y="8" width="19" height="8" rx="1.5"/><path d="M6.5 8v3M10 8v4M13.5 8v3M17 8v4"/>',
    phone: '<path d="M5 4h3.5l1.5 4-2 1.5a10 10 0 0 0 6.5 6.5L16 14l4 1.5V19a1.5 1.5 0 0 1-1.6 1.5A16 16 0 0 1 3.5 5.6 1.5 1.5 0 0 1 5 4z"/>',
    mail: '<rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="m3.5 7 8.5 6 8.5-6"/>',
    insta: '<rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r=".9"/>',
    heart: '<path d="M12 20s-7.5-4.6-7.5-10A4.2 4.2 0 0 1 12 7.5 4.2 4.2 0 0 1 19.5 10C19.5 15.4 12 20 12 20z"/>',
    spark: '<path d="M12 3.5 13.8 9l5.7 1.8-5.7 1.8L12 18.5l-1.8-5.9-5.7-1.8L10.2 9z"/>'
  };
  function icon(n) { return '<svg class="cc-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (P[n] || P.spark) + '</svg>'; }
  function icons() {
    document.querySelectorAll('[data-i]:not([data-i-done])').forEach(function (el) {
      el.setAttribute('data-i-done', '');
      el.insertAdjacentHTML('afterbegin', icon(el.getAttribute('data-i')));
    });
  }

  /* sizes in stock under the price on product cards */
  var ORDER = ['xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', '3xl', '4xl', '5xl', '6xl'];
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('cc-sz') || '{}'); } catch (e) { cache = {}; }
  function save() { try { sessionStorage.setItem('cc-sz', JSON.stringify(cache)); } catch (e) {} }
  function sizesFor(p) {
    var idx = -1;
    (p.options || []).forEach(function (o, i) { if (String(o.name || o).toLowerCase().indexOf('size') > -1) idx = i; });
    if (idx < 0) return [];
    var seen = {}, out = [];
    p.variants.forEach(function (v) {
      var s = String(v.options[idx]).trim(), k = s.toLowerCase();
      if (!(k in seen)) { seen[k] = out.length; out.push([s, v.available]); } else if (v.available) out[seen[k]][1] = true;
    });
    out.sort(function (a, b) { return ORDER.indexOf(a[0].toLowerCase()) - ORDER.indexOf(b[0].toLowerCase()); });
    return out;
  }
  function paint(card, list) {
    if (card.querySelector('.cc-sz,.cc-ship')) return;
    var price = card.querySelector('product-price'); if (!price) return;
    var html = '';
    if (list && list.length) html += '<div class="cc-sz" aria-label="Sizes in stock">' + list.map(function (s) { return s[1] ? '<span>' + s[0] + '</span>' : '<s>' + s[0] + '</s>'; }).join('') + '</div>';
    html += '<small class="cc-ship">Free shipping · COD available</small>';
    price.insertAdjacentHTML('afterend', html);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return; io.unobserve(e.target);
      var card = e.target, a = card.querySelector('a[href*="/products/"]'); if (!a) return;
      var h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0]; if (!h) return;
      if (cache[h]) return paint(card, cache[h]);
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) { cache[h] = sizesFor(p); save(); paint(card, cache[h]); }).catch(function () { paint(card, []); });
    });
  }, { rootMargin: '200px' }) : null;
  function cards() {
    document.querySelectorAll('product-card:not([data-cc])').forEach(function (c) { c.setAttribute('data-cc', ''); if (io) io.observe(c); else paint(c, []); });
  }

  /* cart drawer and cart page */
  function cart() {
    ['.cart-drawer__summary', '.cart-page__summary'].forEach(function (s) {
      document.querySelectorAll(s).forEach(function (box) {
        var el = box.querySelector('.cart-summary__inner') || box.querySelector('.cart-summary') || box;
        if (el.querySelector('.cc-cart-trust')) return;
        el.insertAdjacentHTML('afterbegin', '<p class="cc-cart-note">Free shipping is applied to your order</p>');
        el.insertAdjacentHTML('beforeend', '<p class="cc-cart-trust"><span data-i="cod">Cash on Delivery</span><span data-i="swap">Easy 3-day returns</span><span data-i="lock">Secure checkout</span></p>');
      });
    });
  }

  function chips() {
    var p = location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.cc-chips a:not([data-t])').forEach(function (a) {
      a.setAttribute('data-t', '');
      if (a.getAttribute('href') === p) a.setAttribute('aria-current', 'page');
    });
  }



  /* Shopify keeps 480p/720p MP4 renditions next to the 1080p file; find them via the HLS playlist */
  var rcache = {};
  function rendition(url, h) {
    var key = url + '|' + h;
    if (rcache[key]) return rcache[key];
    var clean = url.split('?')[0], dir = clean.slice(0, clean.lastIndexOf('/') + 1), hash = clean.split('/').pop().split('.')[0];
    rcache[key] = fetch(dir + hash + '.m3u8').then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      var names = t.split('\n').filter(function (l) { return /\.m3u8$/.test(l.split('?')[0]) && l.indexOf(hash) > -1; });
      var pick = names.filter(function (l) { return l.indexOf('-' + h + 'p.') > -1; })[0];
      if (!pick) return url;
      var m = pick.split('?')[0].split('/').pop().match(/^(\w+)\.((?:SD|HD)-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/);
      return m ? dir + m[1] + '.' + m[2] + '-' + m[3] + '-' + m[4] + '.mp4' : url;
    }).catch(function () { return url; });
    return rcache[key];
  }

  /* reels: muted autoplay while in view, tap opens a full-screen player with sound */
  var lite = (navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''))) || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio > 0.6) {
        if (!v.getAttribute('src') && v.dataset.src && !v.dataset.loading) {
          v.dataset.loading = '1';
          rendition(v.dataset.src, 480).then(function (u) { v.src = u; var q = v.play(); if (q && q.catch) q.catch(function () {}); });
        } else if (v.getAttribute('src')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) v.pause();
    });
  }, { threshold: [0, 0.6, 1] }) : null;
  var dlg, list = [], at = 0;
  function player() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'cc-rm';
    dlg.setAttribute('aria-label', 'Customer reel');
    dlg.innerHTML = '<div class="cc-rm__box"><video playsinline loop></video>' +
      '<button type="button" class="cc-rm__btn cc-rm__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="cc-rm__btn cc-rm__sound" aria-label="Mute">On</button>' +
      '<button type="button" class="cc-rm__btn cc-rm__prev" aria-label="Previous reel">&lsaquo;</button>' +
      '<button type="button" class="cc-rm__btn cc-rm__next" aria-label="Next reel">&rsaquo;</button>' +
      '<div class="cc-rm__foot"><p></p><a href="#"></a></div></div>';
    document.body.appendChild(dlg);
    var vid = dlg.querySelector('video'), snd = dlg.querySelector('.cc-rm__sound');
    function close() { vid.pause(); vid.removeAttribute('src'); vid.load(); document.documentElement.classList.remove('cc-lock'); if (dlg.open) dlg.close(); }
    dlg.querySelector('.cc-rm__close').onclick = close;
    dlg.addEventListener('close', function () { vid.pause(); document.documentElement.classList.remove('cc-lock'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    snd.onclick = function () { vid.muted = !vid.muted; snd.textContent = vid.muted ? 'Off' : 'On'; snd.setAttribute('aria-label', vid.muted ? 'Unmute' : 'Mute'); };
    dlg.querySelector('.cc-rm__prev').onclick = function () { show(at - 1); };
    dlg.querySelector('.cc-rm__next').onclick = function () { show(at + 1); };
    var x0 = null;
    dlg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) show(at + (dx < 0 ? 1 : -1)); x0 = null; });
    return dlg;
  }
  function show(i) {
    if (!list.length) return;
    at = (i + list.length) % list.length;
    var b = list[at], d = player(), vid = d.querySelector('video'), a = d.querySelector('.cc-rm__foot a');
    vid.poster = b.dataset.poster || '';
    var want = at;
    vid.removeAttribute('src');
    vid.muted = false; d.querySelector('.cc-rm__sound').textContent = 'On';
    d.querySelector('.cc-rm__foot p').textContent = b.dataset.label || '';
    if (b.dataset.href) { a.href = b.dataset.href; a.textContent = b.dataset.shop || 'Shop now'; a.style.display = ''; } else a.style.display = 'none';
    rendition(b.dataset.full || b.dataset.src, 720).then(function (u) {
      if (want !== at) return;
      vid.src = u;
      var p = vid.play(); if (p && p.catch) p.catch(function () { vid.muted = true; d.querySelector('.cc-rm__sound').textContent = 'Off'; vid.play().catch(function () {}); });
    });
  }
  function reels() {
    document.querySelectorAll('[data-cc-reels]:not([data-r])').forEach(function (rail) {
      rail.setAttribute('data-r', '');
      var btns = [].slice.call(rail.querySelectorAll('.cc-reel'));
      btns.forEach(function (b, i) {
        var v = b.querySelector('video');
        if (v && vio && !lite) vio.observe(v);
        b.addEventListener('click', function () {
          list = btns; var d = player();
          document.documentElement.classList.add('cc-lock');
          if (d.showModal) d.showModal(); else d.setAttribute('open', '');
          rail.querySelectorAll('video').forEach(function (x) { x.pause(); });
          show(i);
        });
      });
    });
  }

  var queued = false;
  function run() { cart(); icons(); cards(); chips(); reels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; run(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
